<template>
  <div>
    <div class="row page-title-header">
      <div class="col-12">
        <div class="page-header">
          <b-breadcrumb class="m-0">
            <b-breadcrumb-item
              :to="{
                name: 'DashboardHome',
              }"
            >
              <i class="fa fa-home"></i>
            </b-breadcrumb-item>
            <b-breadcrumb-item
              :to="{
                name: 'Branches',
              }"
              >分店管理
            </b-breadcrumb-item>
            <b-breadcrumb-item active>店內帳號</b-breadcrumb-item>
          </b-breadcrumb>
        </div>
      </div>
    </div>
    <b-card>
      <div class="d-flex flex-column flex-xl-row mb-4 mb-xl-2 justify-content-between">
        <h4 class="mb-2 mb-xl-0 font-weight-bold">
          店內帳號
        </h4>
        <div
          class="
            d-flex
            flex-column flex-xl-row
            align-items-center
          "
        >
          <b-button
            v-if="$permissions.has($permissions.consts.EXPORT_STAFF_SPECIFIC_URI)"
            class="flex-shrink-0 mb-2 mb-xl-0 mr-2"
            variant="primary"
            @click="exportBindingQrcodes()"
          >
           綁定 QRCode 匯出
          </b-button>
          <b-button
            v-if="$permissions.has($permissions.consts.EXPORT_STAFF_SPECIFIC_URI)"
            class="flex-shrink-0 mb-2 mb-xl-0 mr-2"
            variant="primary"
            @click="exportStaffWithBindingUrls()"
          >
            綁定連結匯出
          </b-button>
          <b-button
            class="flex-shrink-0 mb-2 mb-xl-0 mr-2"
            variant="primary"
            @click="exportStaff()"
          >
            匯出帳號
          </b-button>
          <b-button
            v-if="
              $permissions.has($permissions.consts.BRANCH_DETAIL_CREATE_STAFF)
            "
            class="flex-shrink-0 mb-2 mb-xl-0"
            variant="primary"
            :to="{
              name: 'BranchStaffCreate',
              params: {
                branchID: branchID,
              },
            }"
            ><i class="fa fa-plus"></i>新增帳號
          </b-button>
          <b-dropdown
            class="flex-shrink-0 ml-2"
            variant="primary"
            v-if="$permissions.hasAny([$permissions.consts.BRANCH_DETAIL_CREATE_STAFF, $permissions.consts.STAFF_CHANGE_PASSWORD])"
          >
            <template #button-content>
              <i class="fa fa-plus"></i> 批次上傳
            </template>
            <template v-if="$permissions.has($permissions.consts.BRANCH_DETAIL_CREATE_STAFF)">
              <b-dropdown-item v-b-modal.modal-upload>批次上傳帳號</b-dropdown-item>
              <b-dropdown-item :to="{ name: 'BranchStaffUploadAvatar' }">批次上傳照片</b-dropdown-item>
            </template>
            <template v-if="$permissions.has($permissions.consts.STAFF_CHANGE_PASSWORD)">
              <b-dropdown-item v-b-modal.modal-password-upload>批次更新密碼</b-dropdown-item>
            </template>
          </b-dropdown>
        </div>
      </div>
      <b-breadcrumb class="d-flex items-center" :items="breadcrumb"></b-breadcrumb>
      <b-card-text>
        <div class="row">
          <div class="col-12">
            <b-overlay :show="showLoading" rounded="sm">
              <b-table
                striped
                hover
                responsive
                :items="staffs"
                :fields="fields"
                :sort-desc="query.sort_desc"
                @sort-changed="handleSortChanged"
              >
                <template #cell(avatar_url)="data">
                  <div class="d-flex align-items-center justify-content-center">
                    <b-avatar
                      :src="data.item.avatar_url"
                      variant="secondary"
                      size="2rem"
                    ></b-avatar>
                  </div>
                </template>
                <template #cell(actions)="data">
                  <b-dropdown id="ddown23" variant="secondary">
                    <template slot="button-content">
                      <i class="mdi mdi-menu"></i>
                    </template>
                    <b-dropdown-item
                      :to="{
                        name: 'BranchStaffView',
                        params: {
                          staff_id: data.item.id,
                          branchID: branchID,
                        },
                      }"
                    >
                      查看
                    </b-dropdown-item>
                    <b-dropdown-item
                      v-if="
                        $permissions.has(
                          $permissions.consts.BRANCH_DETAIL_MODIFY_STAFF
                        )
                      "
                      :to="{
                        name: 'BranchStaffForm',
                        params: {
                          staff_id: data.item.id,
                          branchID: branchID,
                        },
                      }"
                    >
                      編輯
                    </b-dropdown-item>
                    <b-dropdown-item
                      v-if="
                        $permissions.has(
                          $permissions.consts.STAFF_BRANCH_MODIFY
                        )
                      "
                      :to="{
                        name: 'BranchStaffSetBranch',
                        params: {
                          staff_id: data.item.id,
                          branchID: branchID,
                        },
                      }"
                    >
                      所屬分店設定
                    </b-dropdown-item>
                    <b-dropdown-item
                      v-if="
                        $permissions.has(
                          $permissions.consts.BRANCH_DETAIL_BOOKING_SHIFT
                        )
                      "
                      :to="{
                        name: 'BookingShiftList',
                        query: { staff_id: data.item.id },
                      }"
                    >
                      班表設定
                    </b-dropdown-item>
                    <b-dropdown-item
                      v-if="
                        $permissions.has(
                          $permissions.consts.STAFF_CUSTOMER_VIEW
                        )
                      "
                      :to="{
                        name: 'BranchStaffCustomerList',
                        params: { staff_id: data.item.id },
                      }"
                    >
                      所屬客戶設定
                    </b-dropdown-item>
                    <b-dropdown-item
                      v-if="
                        $permissions.has(
                          $permissions.consts.STAFF_ROLE_MODIFY
                        )
                      "
                      :to="{
                        name: 'BranchStaffSetRole',
                        params: { staff_id: data.item.id },
                      }"
                    >
                      角色設定
                    </b-dropdown-item>
                    <b-dropdown-item
                      v-if="
                        $permissions.has(
                          $permissions.consts.BRANCH_DETAIL_CHANGE_PASSWORD
                        )
                      "
                      :to="{
                        name: 'BranchStaffChangePassword',
                        params: {
                          staff_id: data.item.id,
                          branchID: branchID,
                        },
                      }"
                    >
                      變更密碼
                    </b-dropdown-item>
                    <b-dropdown-item
                      v-if="
                        $permissions.has(
                          $permissions.consts.BRANCH_DETAIL_DELETE_STAFF
                        ) && data.item.id != user.id
                      "
                      @click="deleteStaff(data.item)"
                    >
                      刪除
                    </b-dropdown-item>
                  </b-dropdown>
                </template>
              </b-table>
            </b-overlay>
          </div>
        </div>
        <div class="d-flex justify-content-center" style="margin-top: 80px">
          <CustomPagination
            :currentPage="query.page"
            :totalRows="totalRows"
            :perPage="query.per_page"
            @page-change="handlePageChange"
            @per-page-change="handlePerPageChange"
          />
        </div>
      </b-card-text>
    </b-card>

    <b-modal id="modal-upload" title="批次上傳">
      <b-overlay :show="showLoadingUpload">
        <div class="form-group">
          <label class="flex-shrink-0 mr-2 mb-0">請上傳帳號 Excel 檔案</label>
          <b-form-file plain @input="uploadStaff" placeholder="尚未選擇檔案" browse-text="瀏覽"></b-form-file>
        </div>
      </b-overlay>
      <template #modal-footer="{ cancel }">
        <b-button
          size="sm"
          variant="outline-primary"
          @click="getSampleExcelFile(getModuleConfig('staff', 'sample_file.staff_import_xls') ,'excel/staff_list.xlsx')"
          ><i class="fa fa-file-text"></i>下載範例檔案</b-button
        >
        <b-button
          variant="outline-danger"
          size="sm"
          class="float-right"
          @click="cancel()"
        >
          關閉
        </b-button>
      </template>
    </b-modal>

    <b-modal id="modal-password-upload" title="批次更新密碼">
      <b-overlay :show="showLoadingUpload">
        <div class="form-group">
          <label class="flex-shrink-0 mr-2 mb-0">請上傳密碼 Excel 檔案</label>
          <b-form-file plain @input="uploadPassword" placeholder="尚未選擇檔案" browse-text="瀏覽"></b-form-file>
        </div>
      </b-overlay>
      <template #modal-footer="{ cancel }">
        <b-button
          size="sm"
          variant="outline-primary"
          @click="
            getSampleExcelFile(
              getModuleConfig('staff', 'sample_file.staff_password_import_xls'),
              '/excel/staff_password_list.xlsx'
            )
          "
        >
          <i class="fa fa-file-text"></i>下載範例檔案
        </b-button>
        <b-button
          variant="outline-danger"
          size="sm"
          class="float-right"
          @click="cancel()"
        >
          關閉
        </b-button>
      </template>
    </b-modal>
  </div>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import staffApi from "@/apis/staff";
import branchApi from "@/apis/branch";
import excelApi from "@/apis/excel";
import { getSampleExcelFile } from "@/utils/dashboardUtils";
import CustomPagination from "@/components/Page/Dashboard/CustomPagination.vue";
import { paginationMixin } from "@/mixins/pagination";
import { updateQueryFromRoute, updateUrlWithoutReload } from "@/utils/updateUrl";

export default {
  components: { CustomPagination },
  mixins: [paginationMixin],
  data() {
    return {
      totalRows: 0,
      showLoading: true,
      showLoadingUpload: false,
      staffs: [],
      activeBranch: null,
      initialized: false,
      query: {
        page: 1,
        per_page: 10,
        sort_desc: false,
      },
      fields: [
        {
          key: "avatar_url",
          label: "",
        },
        {
          key: "pivot.order",
          label: "順序",
          sortable: true,
        },
        {
          key: "employee_code",
          label: "員工編號",
          sortable: true,
        },
        {
          key: "name",
          label: "姓名",
        },
        {
          key: "mobile_phone",
          label: "手機",
        },
        {
          key: "email",
          label: "E-Mail",
        },
        {
          key: "display_status",
          label: "狀態",
        },
        {
          key: "actions",
          label: "操作",
        },
      ],
    };
  },
  computed: {
    ...mapState("general", {
      organization: (state) => state.organization,
    }),
    ...mapState("auth", {
      user: (state) => state.user,
    }),
    ...mapGetters({
      getModuleConfig: "dashboardModule/getConfig",
    }),
    ...mapGetters("route", ["routeQuery"]),
    branchID() {
      return this.$route.params.branchID;
    },
    queryWatcher() {
      return `${this.query.page}-${this.query.per_page}`;
    },
    breadcrumb() {
      const root = {
        text: "最上層",
        to: {
          name: "Branches",
        },
      };

      const parents =
        this.activeBranch?.parents.map((parent) => {
          // 檢查當前用戶是否為上層分店
          const isUserFromHigherLevel = this.currentBranch &&
            (this.currentBranch.level < parent.parent_level ||
              (this.currentBranch.level === parent.parent_level &&
                this.currentBranch.id === parent.parent_id));

          return {
            text: parent.parent_name,
            ...(isUserFromHigherLevel ? {
              to: {
                name: "BranchesSubLayer",
                params: { branchID: parent.parent_id },
              }
            } : { active: true })
          };
        }) ?? [];

      return [
        root,
        ...parents,
        {
          text: this.activeBranch?.name,
          active: true,
        },
      ]
    },
  },
  watch: {
    queryWatcher: {
      handler() {
        if (!this.initialized) return;
        updateUrlWithoutReload(this.query, this.$store, this.$router);
      },
    },
    routeQuery() {
      if (!this.initialized) return;
      this.getStaffs();
    },
  },
  created() {
    const routeQuery = updateQueryFromRoute(this.$route, this.$store, this.query);
    // Ensure sort_desc is boolean
    this.query = {
      ...routeQuery,
      sort_desc: routeQuery.sort_desc === 'true' || routeQuery.sort_desc === true
    };
  },
  mounted() {
    this.init();
  },
  methods: {
    getSampleExcelFile,
    async init() {
      await this.getBranchInfo();
      await this.getStaffs();
      this.initialized = true;
    },
    async getBranchInfo() {
      try {
        const { data: branchData } = await branchApi.getBranch(this.branchID);
        this.activeBranch = branchData.data;
      } catch (error) {
        console.error(error);
        if (error.status !== 401) {
          this.$swal.fire({
            title: "錯誤",
            type: "error",
            text: "取得分店資料錯誤",
          });
        }
      }
    },
    async getStaffs() {
      this.showLoading = true;
      try {
        const params = {
          ...this.query,
        };
        params.sort_desc = this.query.sort_desc ? 'desc' : 'asc';
        const { data: staffData } = await branchApi.getManagedStaffs(this.branchID, params);

        this.staffs = [];
        const now = new Date();
        staffData.data.forEach((staff) => {
          if (!staff.is_sys_admin) {
            this.staffs.push(staff);
          }
          staff.display_status = staff.is_enabled ? "啟用" : "未啟用";
          if (staff.left_at) {
            const leftAt = new Date(staff.left_at);
            staff.display_status =
              leftAt.getTime() > now.getTime() ? staff.display_status : "離職";
          }
        });
        this.totalRows = staffData.meta.total;
      } catch (error) {
        console.error(error);
        if (error.status !== 401) {
          this.$swal.fire({
            title: "錯誤",
            type: "error",
            text: "取得帳號資料錯誤",
          });
        }
      }
      this.showLoading = false;
    },
    handleSortChanged() {
      this.query.sort_desc = !this.query.sort_desc;
      this.handlePageResetWithoutReload();
    },
    async deleteStaff(staff) {
      await this.$swal
        .fire({
          title: "你確定要刪除嗎？",
          html: `
            <div class="d-block">
              <div class="my-3">
                <div>員工編號：${staff.employee_code}</div>
                <div>姓名：${staff.name}</div>
              </div>
              <div>刪除後，相關資料將無法回復，<br/>請您確認！</div>
            </div>`,
          type: "warning",
          confirmButtonText: "確定刪除",
          cancelButtonText: "不刪除",
          showCancelButton: true,
          confirmButtonColor: "#d33",
          cancelButtonColor: "#3085d6",
          reverseButtons: true,
        })
        .then(async (result) => {
          if (result.value) {
            let response = await staffApi.removeStaff(this.organization, staff);
            if (response.status === 200) {
              this.$swal.fire({
                title: "成功",
                type: "success",
                text: "成功刪除 " + staff.name,
              });
              this.getStaffs();
            }
          }
        });
    },
    async uploadStaff(file) {
      this.showLoadingUpload = true;
      let formData = new FormData();
      formData.append("file", file);

      try {
        let response = await branchApi.importStaff(this.branchID, formData);

        if (response.status === 200 && response.data.status === "success") {
          this.$swal.fire({
            title: "上傳成功",
            type: "success",
          });

          this.getStaffs();
        }
      } catch (e) {
        console.error(e);
        if (e.response.status === 422 && e.response.data.message[0]) {
          this.$swal.fire({
            title: "檔案內容有誤",
            type: "error",
            text: e.response.data.message[0] ?? null,
          });
        } else {
          this.$swal.fire({
            title: "上傳失敗",
            type: "error",
          });
        }
      } finally {
        this.showLoadingUpload = false;
        this.$bvModal.hide("modal-upload");
      }
    },
    promptForExportingRequestSubmitted() {
      this.$swal({
        title: "成功",
        text: "可至“我的主控台”查看紀錄及下載檔案",
        type: "success",
        showCancelButton: true,
        confirmButtonText: "前往查看",
        cancelButtonText: "確認",
      }).then((result) => {
        if (result.value) {
          this.$router.push({
            name: "MyConsoleDownloadFileList",
            params: { org_code: this.$route.params.org_code },
          });
        } else {
          return;
        }
      });
    },
    async exportStaff() {
      excelApi.export('staff_under_branch', { branch_id: this.branchID })
        .then(this.promptForExportingRequestSubmitted);
    },
    async exportStaffWithBindingUrls() {
      excelApi.export('staff_under_branch_with_binding_url', { branch_id: this.branchID })
        .then(this.promptForExportingRequestSubmitted);
    },
    async exportBindingQrcodes() {
      excelApi.export('staff_under_branch_qrcode', { branch_id: this.branchID })
        .then(this.promptForExportingRequestSubmitted);
    },
    async uploadPassword(file) {
      this.showLoadingUpload = true;
      let formData = new FormData();
      formData.append("file", file);

      try {
        let response = await staffApi.uploadPassword(formData, this.branchID);

        if (response.status === 200 && response.data.status === "success") {
          const data = response.data.data;

          this.$swal.fire({
            title: "上傳成功",
            type: "success",
            text: `${data.success_count} 更新成功、${data.not_found_count} 找不到`
          });
        }
      } catch (e) {
        this.handleUploadError(e);
      } finally {
        this.showLoadingUpload = false;
        this.$bvModal.hide("modal-password-upload");
      }
    },
  },
};
</script>

<style>
.modal-backdrop {
  opacity: 0.5;
}
</style>
